import React from "react";
import styles from "../../../../styles";
import { withStyles } from "@material-ui/core";
import { MapAutoZoom } from "../../../../../../../layout/layoutHeader/components";
import CustomToggler from "../../../../../../../layout/layoutHeader/components/CustomToggler";
import DrawingToolsBox from "../../../../common/DrawTools/DrawingToolsBox";
import {
  Fullscreen as MaximizeIcon,
  FullscreenExit as MinimizeIcon,
} from "@material-ui/icons";
import Tooltip from "../../../../../../common/StyledToolTip";

const MapHeader = ({
  classes,
  isAutoZoomEnabled,
  toggleRouteAnimation,
  userData,
  Events,
  isMapMaximized,
  toggleMaximize,
  isDropYardRegionEnabled,
  handleDropYardRegionToggle,
}) => {
  return (
    <header
      className={`${classes.moduleHeader} ${classes.anchorPointHeader}`}
      data-automationid="DropYardMap-title"
    >
      Drop Yard Map
      <span className={classes.anchorPointAutoZoom}>
        <MapAutoZoom
          isEnabled={isAutoZoomEnabled}
          toggleRouteAnimation={toggleRouteAnimation}
          userData={userData}
          isMenuItem={true}
          eventHub={Events}
          title={`${isAutoZoomEnabled ? "Disable" : "Enable"} Auto Zoom`}
        />
        <CustomToggler
          key="dropYardRegionToggler"
          title="Drop Yard Region"
          tooltip={"Enable to mark drop yard region"}
          isEnabled={isDropYardRegionEnabled}
          handleToggle={handleDropYardRegionToggle}
          customClass={classes.headerActionLeftBorder}
        />
        {isDropYardRegionEnabled && <DrawingToolsBox lasso />}
        <div
          className={`${classes.headerIconStyles} glHeaderIcons`}
          onClick={toggleMaximize}
        >
          <Tooltip title={isMapMaximized ? "Minimize" : "Maximize"}>
            {isMapMaximized ? <MinimizeIcon /> : <MaximizeIcon />}
          </Tooltip>
        </div>
      </span>
    </header>
  );
};

export default withStyles(styles)(MapHeader);
